export enum AppHierarchy {
  Organisation = 'organisation',
  Project = 'project',
  Team = 'team',
}
